module.exports = "<li class=\"gw-bullet-list\" gw-partial=\"Item\"></li>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/layouts/templates/BulletList.html
// module id = 583
// module chunks = 0